// extracted by mini-css-extract-plugin
export default {"cardImg":"Exercises_cardImg__Ftk32","ex":"Exercises_ex__EoNcu"};